<template>
  <div class="popup" id="popup">
    <div class="popup__content popup--animate">
      <div class="popup__header">
        <svg class="popup__icon">
          <use href="@/assets/sprite.svg#icon-group"></use>
        </svg>
        <h1 class="heading-tertiary">{{ $t('popup.groupAbility.setAcls.title') }}</h1>
      </div>
      <div class='popup__form'>
        <form @submit.prevent="setAcls" class="form" id="setAclsForm">
          <span class="userpopup__roles-label u-margin-bottom-tiny">{{ $t('popup.groupAbility.setAcls.descriptive', { name: role.name }) }}</span>
          <div class="userpopup__tree-container">
            <el-tree :data="data_tree" node-key="id" @node-click="onClickNode" default-expand-all :expand-on-click-node="false">
              <div class="userpopup__tree-node" slot-scope="{ node, data }">
                <div>{{ node.label }}</div>
                <div v-if="data.children">
                  <svg v-show="data.acl === -1" class="userpopup__tree-icon">
                    <use href="../../assets/sprite.svg#icon-minus"></use>
                  </svg>
                  <svg v-show="data.acl === true" class="userpopup__tree-icon userpopup__tree-icon--ok">
                    <use href="../../assets/sprite.svg#icon-checkmark"></use>
                  </svg>
                  <svg v-show="data.acl === false" class="userpopup__tree-icon userpopup__tree-icon--nok">
                    <use href="../../assets/sprite.svg#icon-cancel"></use>
                  </svg>
                </div>
                <div v-else>
                  <svg v-show="data.acl === true" class="userpopup__tree-icon userpopup__tree-icon--ok">
                    <use href="../../assets/sprite.svg#icon-checkmark"></use>
                  </svg>
                  <svg v-show="data.acl === false" class="userpopup__tree-icon userpopup__tree-icon--nok">
                    <use href="../../assets/sprite.svg#icon-cancel"></use>
                  </svg>
                </div>
              </div>
            </el-tree>
          </div>
        </form>
      </div>
      <div class="popup__footer">
        <button class="popup__link u-pointer" type="button" form="setAclsForm" @click='close'>{{ $t('popup.groupAbility.setAcls.cancelAction') }}</button>
        <button class="popup__link u-pointer" type="submit" form="setAclsForm">{{ $t('popup.groupAbility.setAcls.confirmAction') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CLIENT } from '@/axios-wrapper'
import { formMixin } from '@/components/Mixins/Form'
import { toastMixin } from '@/components/Mixins/Toast'

export default {
  data: function () {
    return {
      data_tree: []
    }
  },
  mixins: [formMixin, toastMixin],
  props: ['role'],
  mounted () {
    this.getAbilitiesFromAction('all')
    this.getAbilitiesFromAction('users')
    this.getAbilitiesFromAction('groupabilities')
    this.getAbilitiesFromAction('abilities')
  },
  methods: {
    close () {
      this.$emit('popup:close')
      this.$store.commit('groupAbility/SHOW_SETACLS_GROUPABILITY_POPUP', false)
    },
    onClickNode (data, node) {
      data.acl = !data.acl
      if (data.children) data.children.forEach(n => { n.acl = data.acl })
      else node.parent.data.acl = -1
    },
    async getAbilitiesFromAction (action) {
      try {
        let { data } = await HTTP_CLIENT.get(`ability?subject[$eq]=${action}`)

        // Affichage du nom de la collection mongodb qui sera soumise à la gestion des droits d'accès
        let label = ''
        switch (action) {
          case 'users': label = this.$t('popup.groupAbility.setAcls.users')
            break
          case 'groupabilities': label = this.$t('popup.groupAbility.setAcls.roles')
            break
          case 'abilities': label = this.$t('popup.groupAbility.setAcls.abilities')
            break
          case 'all': label = this.$t('popup.groupAbility.setAcls.superuser')
            break
        }

        // ----- Création de la structure de données JSON requise pour le widget el-tree d'element-ui ------
        let dataJson = `{ "label": "${label}", "acl": -1, "children": [`

        // Parcourt des droits d'accès existants pour la collection mongodb à traiter
        data.forEach((obj, index) => {
          if (index > 0) dataJson += ','

          // Récupération des droits d'accès déjà positionnés pour la collection mongodb à traiter
          let acl = this.role.abilities.find(acl => acl._id === obj._id)
          if (acl === undefined) acl = false
          else acl = true

          // Ajout des droits d'accès à la structure de données JSON requise pour le widget el-tree
          dataJson += `{ "id": "${obj._id}", "label": "${obj.name}", "acl": ${acl}}`
        })
        dataJson += ']}'
        // ----- Fin Création de la structure de données -----

        // Conversion du JSON en objet JS pour alimenter le widget el-tree
        this.data_tree.push(JSON.parse(dataJson))
      } catch (error) { console.log(error) }
    },
    async setAcls () {
      // Récupération des droits d'accès à mettre à jour dans un tableau contenant les id mongodb des droits d'accès ( collection abilities )
      let acls = this.data_tree
        .map(tNode => tNode.children.filter(node => node.acl === true))
        .flat()
        .map(n => n.id)

      if (acls.length > 0) {
        try {
          await HTTP_CLIENT.put(`groupability/${this.role._id}/ability`, {
            ids: acls
          })
        } catch (error) { console.log(error) }
      }

      this.close()
      this.sendSuccessToast(this.$t('feedback-ok.groupAbility.setAcls', { name: this.role.name }))
    }
  }
}
</script>
